// extracted by mini-css-extract-plugin
export var actionIcon = "_kh-0";